import PropTypes from 'prop-types'
import { Component } from 'react'

// eslint-disable-next-line
import Text from 'components/common/Text'
import theme from 'theme'

const DEFAULT_PROP_TYPES = PropTypes.oneOfType([PropTypes.node, PropTypes.func])

const isString = (t) => typeof t === 'string'

export default class Row extends Component {
  static propTypes = {
    label: DEFAULT_PROP_TYPES,
    value: DEFAULT_PROP_TYPES,
    action: DEFAULT_PROP_TYPES,
    children: PropTypes.node,
    className: PropTypes.string
  }

  evaluateRender(value) {
    if (typeof value === 'function') {
      return value()
    }

    return value
  }

  render() {
    const { label, value, action, children, ...restProps } = this.props
    const evaluatedLabel = this.evaluateRender(label)
    const evaluatedValue = this.evaluateRender(value)
    const evaluatedAction = this.evaluateRender(action)

    return (
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          paddingTop: theme.space[4],
          paddingBottom: theme.space[4],
          borderBottom: `1px solid ${theme.colors.borderContrast}`
        }}
        {...restProps}
      >
        <div
          css={{
            display: 'grid',
            gap: theme.space[3],
            alignItems: 'center',
            paddingLeft: theme.space[2],
            paddingRight: theme.space[2],
            width: '100%',
            gridAutoColumns: 'auto',
            gridTemplateColumns: evaluatedLabel
              ? 'minmax(64px, 0.66fr) repeat(2, minmax(64px, 1fr))'
              : 'minmax(64px, 1.33fr) minmax(64px, 0.66fr)'
          }}
        >
          {evaluatedLabel &&
            (isString(evaluatedLabel) ? (
              <Text as="h4">{evaluatedLabel}</Text>
            ) : (
              evaluatedLabel
            ))}

          {evaluatedValue && (
            <div
              css={{
                gridColumn:
                  !evaluatedAction && `${evaluatedLabel ? '2' : '1'} / span 2`
              }}
            >
              {isString(evaluatedValue) ? (
                <Text as="p" color="medium">
                  {evaluatedValue}
                </Text>
              ) : (
                evaluatedValue
              )}
            </div>
          )}

          {evaluatedAction && (
            <div
              css={{
                justifySelf: 'end'
              }}
            >
              {evaluatedAction}
            </div>
          )}
        </div>
        {children && (
          <div
            css={{
              paddingTop: theme.space[3],
              paddingBottom: theme.space[3]
            }}
          >
            {children}
          </div>
        )}
      </div>
    )
  }
}
